import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';

import { InvestorDetailsSummaryTabHouseholdSummaryQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { allEntitiesSummaryTableColumns } from '../../../constants';
import AllEntitiesSummaryMobileTableSumFooter from './mobileSumFooter';

interface AllEntitiesSummaryMobileTableProps {
  tableRows: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['data'];
  showSpecificColumns: boolean;
  tableTotalRowData: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['totals'] | null;
  handleEntitySelect: ({ entityId, isGroup }: { entityId: string; isGroup: boolean }) => void;
}

const AllEntitiesSummaryMobileTable = ({
  tableRows,
  showSpecificColumns,
  tableTotalRowData,
  handleEntitySelect
}: AllEntitiesSummaryMobileTableProps) => {
  const TableRow = ({ el }: { el: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['data'][number] }) => {
    const isGroup = el.groupedLegalEntitiesSummary?.length ? true : false;
    return (
      <MobileTableRowWrap key={el.primaryLegalEntityId}>
        <MobileRow>
          <MobileRowTitle>{allEntitiesSummaryTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => handleEntitySelect({ entityId: el.primaryLegalEntityId, isGroup })}>
            {el.name}
          </MobileRowValue>
        </MobileRow>
        {showSpecificColumns && (
          <MobileRow>
            <MobileRowTitle>{allEntitiesSummaryTableColumns[1].title}</MobileRowTitle>
            <MobileRowValue>
              <FormattingTooltip zIndex={1000}>{+el.totalEntityValue}</FormattingTooltip>
            </MobileRowValue>
          </MobileRow>
        )}

        {showSpecificColumns && (
          <MobileRow>
            <MobileRowTitle>{allEntitiesSummaryTableColumns[2].title}</MobileRowTitle>
            <MobileRowValue>{el.privateCapitalPercentage?.toFixed(2)}%</MobileRowValue>
          </MobileRow>
        )}

        <MobileRow>
          <MobileRowTitle>{allEntitiesSummaryTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.currentNAV}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{allEntitiesSummaryTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.unfundedCommitment}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        {showSpecificColumns && (
          <MobileRow>
            <MobileRowTitle>{allEntitiesSummaryTableColumns[5].title}</MobileRowTitle>
            <MobileRowValue>
              {el.ignoreAllocationTargets ? (
                '--'
              ) : el.targetOverCommitmentRatio === null ? (
                <>Pacing Model</>
              ) : (
                <>OC Ratio {el.targetOverCommitmentRatio}</>
              )}
            </MobileRowValue>
          </MobileRow>
        )}

        {showSpecificColumns && (
          <MobileRow>
            <MobileRowTitle>{allEntitiesSummaryTableColumns[6].title}</MobileRowTitle>
            <MobileRowValue>{el.ignoreAllocationTargets ? '--' : <FormattingTooltip zIndex={1000}>{+el.capacity}</FormattingTooltip>}</MobileRowValue>
          </MobileRow>
        )}
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableRows.length ? (
        <>
          {tableRows.map((el, index) => {
            return <TableRow el={el} key={index} />;
          })}
          <AllEntitiesSummaryMobileTableSumFooter tableTotalRowData={tableTotalRowData} showSpecificColumns={showSpecificColumns} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default AllEntitiesSummaryMobileTable;
